import { useNavigate } from "react-router-dom";
import { ROUTE_PATH, STORAGE_KEY } from "../constants";
import Button from "./common/Button";
import { useTranslation } from "react-i18next";

const BookingButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoToOtherReservations = () => {
    const config = localStorage.getItem(STORAGE_KEY.CONFIG);
    const { hotelId } = config ? JSON.parse(config) : "";
    navigate(ROUTE_PATH.BOOKING.replace(":hotelId", hotelId));

    localStorage.clear();
  };

  return (
    <Button variant="outlined" onClick={handleGoToOtherReservations}>
      {t("other_reservations")}
    </Button>
  );
};

export default BookingButton;
